import fetcher from 'api/fetcher';
import axios from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import creationWizardFiltersFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/main_page/creation_wizard_filters_form_submit';
import { urlParser } from '@hh.ru/browser-api-utils';

import { setWizardVacancies, setWizardVacanciesIsLoading, WizardVacancy } from 'store/models/campaignCreationWizard';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchWizardVacancySearch =
    ({ nameFilter, abortSignal }: { nameFilter?: string; abortSignal?: AbortSignal }): AppThunkAction<Promise<void>> =>
    (dispatch, getState) => {
        const { vacancySearchValue, selectedFilterValues } = getState().campaignCreationWizard;

        dispatch(setWizardVacanciesIsLoading(true));

        const areaIds = selectedFilterValues.areas.map((f) => f.value);
        const usersIds = selectedFilterValues.users.map((f) => f.value);

        const queryStr = urlParser.stringify({
            nameFilter: nameFilter === undefined ? vacancySearchValue : nameFilter,
            areaId: areaIds,
            usersId: usersIds,
        });

        const searchValue = nameFilter === undefined ? vacancySearchValue : nameFilter;
        const analyticsParams = {
            searchValue,
            areaIds: areaIds.toString() || null,
            managerIds: usersIds.toString() || null,
        };

        return fetcher
            .get<unknown, WizardVacancy[]>(`/api/v1/vacancy/active_vacancies/?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((vacancies) => {
                dispatch(setWizardVacancies(vacancies));
                creationWizardFiltersFormSubmit(analyticsParams);
            })
            .catch((err) => {
                if (axios.isCancel(err) || abortSignal?.aborted) {
                    return;
                }
                dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
                creationWizardFiltersFormSubmit({ ...analyticsParams, errors: JSON.stringify(err) });
            })
            .finally(() => {
                dispatch(setWizardVacanciesIsLoading(false));
            });
    };
